export function throttle(func, timeout = 300) {
  let lastRun;
  return (...args) => {
    const now = Date.now();
    if (!lastRun || now - lastRun >= timeout) {
      func.apply(this, args);
      lastRun = now;
    }
  };
}
